var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewAllIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99954 3.83301C2.91088 3.83301 1.38154 8.24434 1.36754 8.28901L1.29688 8.49967L1.36688 8.71034C1.38154 8.75501 2.91088 13.1663 7.99954 13.1663C13.0882 13.1663 14.6175 8.75501 14.6315 8.71034L14.7022 8.49967L14.6322 8.28901C14.6175 8.24434 13.0882 3.83301 7.99954 3.83301ZM7.99954 11.1663C6.52887 11.1663 5.33288 9.97034 5.33288 8.49967C5.33288 7.02901 6.52887 5.83301 7.99954 5.83301C9.47021 5.83301 10.6662 7.02901 10.6662 8.49967C10.6662 9.97034 9.47021 11.1663 7.99954 11.1663Z",
    fill: "#1F242E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 7.16699C7.27766 7.16699 6.66699 7.77766 6.66699 8.50033C6.66699 9.22299 7.27766 9.83366 8.00033 9.83366C8.72299 9.83366 9.33366 9.22299 9.33366 8.50033C9.33366 7.77766 8.72299 7.16699 8.00033 7.16699Z",
    fill: "#1F242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAllIcon);
export default __webpack_public_path__ + "static/media/view_all_icon.78889b3a8140be946031fdb5d3e595ad.svg";
export { ForwardRef as ReactComponent };